import React from 'react';
import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { NumberInput } from '~/eds/src/components/NumberInput/NumberInput';
import { Filter } from '~/evifields/src/types/Filter';
import { NumberValue } from '~/evifields/src/types/Value';
import { Nullable } from '~/types/Nullable';

interface Props {
  filter: Filter<NumberValue>;
  onChange: (updatedValues: NumberValue[]) => void;
}

export const NumberValues = ({ filter, onChange }: Props) => {
  const intl = useIntl();
  const { id, operatorId, values } = filter;
  const [min = null, max = null] = values;

  const handleValueChange = (updatedValue: Nullable<number>) => {
    onChange(updatedValue !== null ? [updatedValue] : []);
  };

  const handleFirstValueChange = (updatedMin: Nullable<number>) => {
    onChange([updatedMin, max]);
  };

  const handleSecondValueChange = (updatedMax: Nullable<number>) => {
    onChange([min, updatedMax]);
  };

  switch (operatorId) {
    case 'between': {
      return (
        <Layout spacing={2}>
          <NumberInput
            name={`${id}-min`}
            value={min}
            max={max}
            placeholder={intl.formatMessage({
              id: 'NumberValues.minPlaceholder',
              defaultMessage: 'Min',
              description: 'Placeholder for minimum value input',
            })}
            width="50%"
            onChange={handleFirstValueChange}
          />
          <NumberInput
            name={`${id}-max`}
            value={max}
            min={min}
            placeholder={intl.formatMessage({
              id: 'NumberValues.maxPlaceholder',
              defaultMessage: 'Max',
              description: 'Placeholder for maximum value input',
            })}
            width="50%"
            onChange={handleSecondValueChange}
          />
        </Layout>
      );
    }
    default:
      return (
        <NumberInput
          name={id}
          value={min}
          placeholder={intl.formatMessage({
            id: 'NumberValues.numberPlaceholder',
            defaultMessage: 'Number',
            description: 'Placeholder for number input',
          })}
          width="100%"
          onChange={handleValueChange}
        />
      );
  }
};
